import { useCallback, useState } from 'react';

/**
 * Server-searched pickers query only once the user reaches them (focus /
 * click), not on mount: a form or filter bar that is never touched costs no
 * request. Spread `onFocus` on the picker's wrapper and pass `active` as (part
 * of) the picker's `enabled`. The chosen value still shows from the picker's
 * `selectedLabelFallback`.
 */
export const useActivateOnFocus = () => {
  const [active, setActive] = useState(false);
  const onFocus = useCallback(() => setActive(true), []);
  return { active, onFocus };
};
